import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonProps, ButtonSizeVariants } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { useTheme } from "styled-components";

export interface ResponsiveButtonProps extends InjectableCss {
    breakpoint?: BreakpointKey;
    buttonProps?: ButtonProps;
    smallSizeVariant?: ButtonSizeVariants;
    largeSizeVariant?: ButtonSizeVariants;
}

const ResponsiveButton: React.FC<ResponsiveButtonProps> = ({
    children,
    css,
    breakpoint = "lg",
    buttonProps,
    smallSizeVariant = "small",
    largeSizeVariant = "medium",
}) => {
    const { breakpoints } = useTheme() as BaseTheme;
    const breakpointKeys = breakpoints.keys as Array<BreakpointKey>;

    const breakpointIndex = breakpointKeys.indexOf(breakpoint);
    const aboveBreakpoint = breakpointKeys[breakpointIndex - 1];
    const belowBreakpoint = aboveBreakpoint ? breakpoint : breakpointKeys[0];

    return (
        <StyledWrapper css={css}>
            {aboveBreakpoint ? (
                <Hidden above={aboveBreakpoint}>
                    <Button sizeVariant={smallSizeVariant} {...buttonProps}>
                        {children}
                    </Button>
                </Hidden>
            ) : null}
            <Hidden below={belowBreakpoint}>
                <Button sizeVariant={largeSizeVariant} {...buttonProps}>
                    {children}
                </Button>
            </Hidden>
        </StyledWrapper>
    );
};

export default ResponsiveButton;
